import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import { Icon } from "@mui/material";

const PXIframe = ({ url, reponame, username }) => {
  const copyLink = () => {
    const el = document.createElement("input");
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    alert(`${reponame} link copied`);
  };
  return (
    <Card sx={{ maxWidth: "100%" }}>
      <CardHeader
        avatar={<Avatar aria-label="recipe">  R </Avatar>}
        action={<Icon className="ml-5"> <span onClick={(e) => { e.preventDefault(); copyLink(); }}>content_copy</span> </Icon>}
        title={reponame}
        subheader={`by ${username}`}
      />
    </Card>
  );
};

export default PXIframe;
